import type { PublicSlotKey } from '@/apilib';
import type { ImageUploadToStageApi } from './imageUploadToStageApi';

export const ImageUploadToStageApiKey: PublicSlotKey<ImageUploadToStageApi> = {
  name: 'ImageUploadToStageApi',
  public: true,
};
